import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {cloudLight} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {},
  header: {
    paddingVertical: indent,
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  listItem: {
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  loadingBoxOrderingEntities: {
    height: 20,
    width: 70,
  },
  loadingBoxActivationDate: {
    height: 20,
    width: 90,
  },
  loadingBoxBusinessCoach: {
    height: 20,
    width: 80,
  },
  loadingBoxHighestAchievedRank: {
    height: 20,
    width: 70,
  },
  loadingBoxQualifyingPoints: {
    height: 20,
    width: 80,
  },
});
